<template>
  <div id="swagger-ui">
    <b-row v-if="loading" class="mt-5 align-items-center justify-content-center">

      <b-spinner/>
    </b-row>
  </div>
</template>
<script>
import api from '@/services/api'
import 'swagger-ui/dist/swagger-ui.css'
import SwaggerUI from 'swagger-ui'
import auth from "@/services/auth"

export default {
  data () {
    return {
      loading: true
    }
  },
  async mounted () {
  
    const swaggerJSON = await api.getSwagger()
    this.loading = false
    SwaggerUI({
      spec: swaggerJSON,
      // url: 'https://petstore3.swagger.io/api/v3/openapi.json',
      dom_id: '#swagger-ui',
      requestInterceptor: req => {
        req.headers["Authorization"] = `Bearer ${auth.getToken()}`
      }
    })
  }
}
</script>

<style scoped>
 code {
  background-color: transparent;
 }
</style>